/*
  "Complete your routine" block (snippets/product-routine.liquid).
  - Lazy-loads complementary products when the block nears the viewport (falls back to related products).
  - One-tap add to cart, variant picker per row, "Add all" with live total.
  - Uses Shopify's Cart API and refreshes the theme's mini cart.
*/
(function () {
  if (window.__routinePicksLoaded) return;
  window.__routinePicksLoaded = true;

  var ADDED_MS = 2200;

  /* ---------- helpers ---------- */
  function money(cents, currency) {
    try {
      return new Intl.NumberFormat('en-GB', { style: 'currency', currency: currency || 'GBP' }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2);
    }
  }

  function currentVariant(item) {
    var select = item.querySelector('.rp-variant');
    if (select && select.options.length) {
      var o = select.options[select.selectedIndex];
      return {
        id: o.value,
        price: parseInt(o.getAttribute('data-price'), 10) || 0,
        priceText: o.getAttribute('data-price-text') || '',
        compareText: o.getAttribute('data-compare-text') || '',
        image: o.getAttribute('data-image') || ''
      };
    }
    return {
      id: item.getAttribute('data-variant-id'),
      price: parseInt(item.getAttribute('data-price'), 10) || 0,
      priceText: item.getAttribute('data-price-text') || '',
      compareText: item.getAttribute('data-compare-text') || '',
      image: ''
    };
  }

  function setStatus(root, message, isError) {
    var el = root.querySelector('.rp-status');
    if (!el) return;
    el.textContent = message || '';
    el.classList.toggle('is-error', !!isError);
  }

  /* ---------- totals for "Add all" ---------- */
  function updateAddAll(root) {
    var btn = root.querySelector('.rp-add-all');
    if (!btn) return;
    var count = 0;
    var total = 0;
    root.querySelectorAll('.rp-item').forEach(function (item) {
      var check = item.querySelector('.rp-check__input');
      if (check && !check.checked) return;
      count += 1;
      total += currentVariant(item).price;
    });
    var label = btn.querySelector('.rp-add-all__label');
    var base = root.getAttribute('data-label-add-all') || 'Add all';
    if (label) label.textContent = count ? base + ' (' + count + ') · ' + money(total, root.getAttribute('data-currency')) : base;
    btn.disabled = count === 0;
  }

  /* ---------- cart ---------- */
  function addToCart(items) {
    return fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (response) {
      return response.json().then(function (data) {
        return { ok: response.ok, data: data };
      });
    });
  }

  function refreshCart(root) {
    if (!window.Alpine || !window.Alpine.store) return;
    var mini = window.Alpine.store('xMiniCart');
    if (!mini) return;
    mini.reLoad();
    if (root.getAttribute('data-open-cart') === 'true') {
      setTimeout(function () { mini.openCart(); }, 350);
    }
  }

  function flashAdded(btn, root) {
    var label = btn.querySelector('.rp-add__label');
    var original = root.getAttribute('data-label-add') || 'Add';
    btn.classList.remove('is-loading');
    btn.classList.add('is-added');
    if (label) label.textContent = root.getAttribute('data-label-added') || 'Added';
    setTimeout(function () {
      btn.classList.remove('is-added');
      if (label) label.textContent = original;
    }, ADDED_MS);
  }

  function handleAdd(root, items, button, onDone) {
    setStatus(root, '', false);
    button.classList.add('is-loading');
    var label = button.querySelector('.rp-add__label, .rp-add-all__label');
    var previous = label ? label.textContent : '';
    if (label && root.getAttribute('data-label-adding')) label.textContent = root.getAttribute('data-label-adding');

    addToCart(items)
      .then(function (result) {
        if (!result.ok) {
          button.classList.remove('is-loading');
          if (label) label.textContent = previous;
          setStatus(root, (result.data && (result.data.description || result.data.message)) || root.getAttribute('data-label-error') || 'Something went wrong.', true);
          return;
        }
        refreshCart(root);
        onDone();
        setStatus(root, root.getAttribute('data-label-added') || 'Added', false);
        document.dispatchEvent(new CustomEvent('routine-picks:added', { detail: { items: items } }));
      })
      .catch(function () {
        button.classList.remove('is-loading');
        if (label) label.textContent = previous;
        setStatus(root, root.getAttribute('data-label-error') || 'Something went wrong.', true);
      });
  }

  /* ---------- events ---------- */
  document.addEventListener('click', function (event) {
    var addBtn = event.target.closest && event.target.closest('.routine-picks .rp-add');
    if (addBtn) {
      var root = addBtn.closest('.routine-picks');
      var item = addBtn.closest('.rp-item');
      var variant = currentVariant(item);
      handleAdd(root, [{ id: variant.id, quantity: 1 }], addBtn, function () { flashAdded(addBtn, root); });
      return;
    }

    var allBtn = event.target.closest && event.target.closest('.routine-picks .rp-add-all');
    if (allBtn) {
      var rootAll = allBtn.closest('.routine-picks');
      var items = [];
      rootAll.querySelectorAll('.rp-item').forEach(function (row) {
        var check = row.querySelector('.rp-check__input');
        if (check && !check.checked) return;
        items.push({ id: currentVariant(row).id, quantity: 1 });
      });
      if (!items.length) return;
      handleAdd(rootAll, items, allBtn, function () {
        allBtn.classList.remove('is-loading');
        updateAddAll(rootAll);
        rootAll.querySelectorAll('.rp-item .rp-add').forEach(function (b) { flashAdded(b, rootAll); });
      });
    }
  });

  document.addEventListener('change', function (event) {
    var root = event.target.closest && event.target.closest('.routine-picks');
    if (!root) return;

    if (event.target.matches('.rp-variant')) {
      var item = event.target.closest('.rp-item');
      var v = currentVariant(item);
      var now = item.querySelector('.rp-price__now');
      var was = item.querySelector('.rp-price__was');
      if (now) now.textContent = v.priceText;
      if (was) {
        was.textContent = v.compareText;
        was.hidden = !v.compareText;
      }
      var img = item.querySelector('.rp-media__img');
      if (img && v.image) {
        img.src = v.image;
        img.removeAttribute('srcset');
      }
    }
    updateAddAll(root);
  });

  /* ---------- lazy loading ---------- */
  function showResult(root, source) {
    root.innerHTML = source.innerHTML;
    root.classList.remove('routine-picks--loading');
    root.removeAttribute('data-url');
    root.removeAttribute('data-fallback-url');
    root.setAttribute('aria-busy', 'false');
    updateAddAll(root);
  }

  function load(root, useFallback) {
    var url = useFallback ? root.getAttribute('data-fallback-url') : root.getAttribute('data-url');
    if (!url) {
      root.hidden = true;
      return;
    }
    fetch(url)
      .then(function (response) { return response.text(); })
      .then(function (text) {
        var holder = document.createElement('div');
        holder.innerHTML = text;
        var source = holder.querySelector('.routine-picks[data-routine-picks="' + root.getAttribute('data-block-id') + '"]');
        if (source && source.querySelector('.rp-item')) {
          showResult(root, source);
        } else if (!useFallback && root.getAttribute('data-fallback-url')) {
          load(root, true);
        } else {
          root.hidden = true;
        }
      })
      .catch(function () { root.hidden = true; });
  }

  var observer = 'IntersectionObserver' in window
    ? new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          observer.unobserve(entry.target);
          load(entry.target, false);
        });
      }, { rootMargin: '400px 0px' })
    : null;

  function init(scope) {
    (scope || document).querySelectorAll('.routine-picks[data-url]').forEach(function (root) {
      if (root.__rpInit) return;
      root.__rpInit = true;
      if (observer) observer.observe(root);
      else load(root, false);
    });
  }

  init();
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
})();
